<template>
  <v-dialog v-model="dialog" width="1200">
    <v-card v-if="logs" min-height="90vh">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Logs da Atualização </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="logs"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-options': [10, 20, 50]
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogDeLogDeAtualizacao',

  props: ['showDialog', 'logs'],

  data: () => ({
    dialog: false,
    headers: [{ text: 'Mensagem', value: 'mensagem' }]
  }),

  watch: {
    showDialog() {
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },

    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
